import { useQueryClient } from "@tanstack/react-query";

import { type FeatureFlagNamesEnum, type GetFeatureFlagsQuery } from "src/graphql/generated/types";
import { notUndefined } from "src/utils";

/*
This hook should only be used when user is  authenticated
*/
export const useHasFeatureFlagActivated = (feature: FeatureFlagNamesEnum): boolean => {
  const queryClient = useQueryClient();

  const {
    featureFlags: { activatedFeatures },
  } = notUndefined(
    queryClient.getQueryData<GetFeatureFlagsQuery>(["getFeatureFlags"])
  );

  return Boolean(activatedFeatures.find((activatedFeature) => activatedFeature === feature));
};
